import { Button, Skeleton } from '@systemeio/components'
import type { ReactNode } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { copyTextToClipboard } from 'shared/utils/copy-text-to-clipboard'

const AffiliateCard = ({ children }: { children: ReactNode }) => (
  <section className="bg-bg-primary border-border-100 flex min-w-0 flex-col gap-4 rounded-xl border p-5">
    {children}
  </section>
)

const AffiliateCardTitle = ({ children }: { children: ReactNode }) => (
  <h2 className="text-text-primary flex items-center gap-1.5 text-lg font-medium">{children}</h2>
)

const AffiliateStatRow = ({ label, children }: { label: ReactNode; children: ReactNode }) => (
  <div className="flex items-center justify-between gap-3">
    <dt className="text-text-tertiary">{label}</dt>
    <dd className="text-text-primary font-medium">{children}</dd>
  </div>
)

interface AffiliateCopyFieldProps {
  value: string | undefined
  icon?: ReactNode
  variant?: 'primary' | 'secondary'
}

const AffiliateCopyField = ({ value, icon, variant = 'secondary' }: AffiliateCopyFieldProps) => {
  const { t } = useLocoTranslation()

  return (
    <div className="bg-bg-secondary flex min-w-0 items-center gap-2.5 rounded-md p-1.5 pl-2.5">
      {icon}
      <span className="text-text-tertiary min-w-0 flex-1 truncate" title={value}>
        {value ?? <Skeleton className="h-5 w-40" />}
      </span>
      <Button
        variant={variant}
        size="sm"
        disabled={!value}
        onClick={() => value && void copyTextToClipboard(value)}
      >
        {t('global.copy')}
      </Button>
    </div>
  )
}

export { AffiliateCard, AffiliateCardTitle, AffiliateCopyField, AffiliateStatRow }
